module.exports = __webpack_public_path__ + "static/media/infoicon2.02e1bc2b.svg";